<template>
    <section style="max-height: 100dvh">
        <HeaderComponent :moduleName="$moduleName" :buildMode="envMode" />
        <main id="main">
            <NovoMenu></NovoMenu>
            <section>
                <router-view />
            </section>
        </main>
        <GlobalAiAssistant />
    </section>
</template>

<script>
import { HeaderComponent } from 'roboflex-thalamus-componentes-vue3-lib'
import NovoMenu from "./components/menuLateral/NovoMenu.vue";
import GlobalAiAssistant from "./components/GlobalAiAssistant/GlobalAiAssistant.vue";

export default {
    components: {
        HeaderComponent,
        NovoMenu,
        GlobalAiAssistant,
    },
    data() {
        return {
            // envMode: process.env.NODE_ENV
            envMode: 'production'
        };
    }
}
</script>
<style>

.multiselect__tag {
    color: var(--cor-texto) !important;
}

.paginacao-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    width: 100%;
}

.paginacao {
    display: flex;
    gap: 6px;
    justify-content: center;
    flex: 1;

    span {
        cursor: pointer;
    }
}

.paginacao-select {
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: flex-end;

    label {
        margin: 0;
    }
}

select {
    cursor: pointer;
}

option {
    background: var(--cor-bg) !important;
}

.HP {
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent !important;
    width: 2.5rem;
    height: 2.5rem;
    text-align: center;
    border-radius: 50%;
    padding: 0;
    opacity: 1;
}

a:hover {
    cursor: pointer;
}

header {
    position: relative;
    z-index: 100;
}

.anexo {
    border: 1px solid var(--cor-separador);
    border-radius: 10px;
    padding: 5px;
    display: flex;
    justify-content: space-between;
}

div {
    transition: background-color 0.25s, border 0.25s;
}

*::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

*::-webkit-scrollbar-thumb {
    background-color: var(--cor-separador);
    border-radius: 20px;
}

th {
    text-align: center !important;
}

.hPoints {
    display: flex;
    border-radius: 50%;
    margin-right: 5px;
    width: 2rem;
    height: 2rem;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    text-align: center;
}

.botaoAdicionarSprint:hover {
    transition: 50ms linear;
    transform: scale(1.1);
    cursor: pointer;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.abas {
    display: flex;
    height: 2.5rem;
    margin-left: 1.5rem;
    align-items: end;

    a {
        padding: .5em 1em;
        border-radius: 12px 12px 0 0;
        border: 1px solid var(--cor-separador);
        border-bottom: none;
        align-content: center;
    }

    .ativo {
        background-color: var(--cor-primaria);
        color: var(--cor-bg);
        height: 2.8rem;
        transition: all 400ms ease-in-out;
    }
}
</style>
